import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiWifiOff } = FiIcons;

const ConnectionStatus = () => {
  const { supabaseConnected, connectionMessage, loading } = useAuth();

  return (
    <div className={`px-3 py-1 rounded-full flex items-center space-x-1 text-xs transition-colors duration-300 ${
      loading 
        ? 'bg-secondary-800 text-secondary-400' 
        : supabaseConnected 
          ? 'bg-green-900/20 text-green-500 border border-green-500/20' 
          : 'bg-red-900/20 text-red-400 border border-red-500/20'
    }`}>
      {loading ? (
        <div className="animate-spin h-3 w-3 border-t-2 border-secondary-400 rounded-full mr-1"></div>
      ) : (
        <SafeIcon icon={supabaseConnected ? FiCheck : FiWifiOff} className="w-3 h-3" />
      )}
      <span className="hidden md:inline font-medium">
        {loading ? 'Syncing...' : supabaseConnected ? 'Connected' : 'Offline Mode'}
      </span>
      {!supabaseConnected && !loading && (
        <span className="md:hidden">Offline</span>
      )}
    </div>
  );
};

export default ConnectionStatus;